// import React from "react";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { Card, Typography, Button } from "antd";
// import { LeftOutlined } from "@ant-design/icons";
// import { useNavigate } from "react-router-dom";

// ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

// const BoothPercentage = ({ electionDetails }) => {
//   const barChartData = {
//     labels: ["< 45%", "30%-45%", "> 30%", "No Result"],
//     datasets: electionDetails?.map((data) => ({
//       label: data.year,
//       data: [
//         data.position.above45,
//         data.position.thirtyTo45,
//         data.position.below30,
//         data.position.noResult,
//       ],
//       backgroundColor:
//         data.year === "2024"
//           ? "#5555FF"
//           : data.year === "2019"
//           ? "#FFAA33"
//           : "#22AA99",
//     })),
//   };

//   const positionChartData = {
//     labels: ["1st Position", "2nd Position", "3rd Position", "No Position"],
//     datasets: electionDetails?.map((data) => ({
//       label: data.year,
//       data: [
//         data.votePercentage.first,
//         data.votePercentage.second,
//         data.votePercentage.third,
//         data.votePercentage.noPosition,
//       ],
//       backgroundColor:
//         data.year === "2024"
//           ? "#5555FF"
//           : data.year === "2019"
//           ? "#FFAA33"
//           : "#22AA99",
//     })),
//   };

//   return (
//     <div style={{ padding: "20px" }}>
//       {electionDetails.length > 0 ? (
//         <div
//           style={{
//             display: "flex",
//             flexWrap: "wrap",
//             gap: "20px",
//             justifyContent: "center",
//           }}
//         >
//           <Card
//             title="Percentage of Booths"
//             style={{ flex: "1 1 300px", minWidth: "300px" }}
//           >
//             <Bar
//               data={barChartData}
//               options={{
//                 responsive: true,
//                 maintainAspectRatio: false,
//                 scales: { y: { beginAtZero: true } },
//               }}
//             />
//           </Card>
//           <Card
//             title="Position of Booths"
//             style={{ flex: "1 1 300px", minWidth: "300px" }}
//           >
//             <Bar
//               data={positionChartData}
//               options={{
//                 responsive: true,
//                 maintainAspectRatio: false,
//                 scales: { y: { beginAtZero: true } },
//               }}
//             />
//           </Card>
//         </div>
//       ) : null}
//     </div>
//   );
// };

// export default BoothPercentage;

import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Card } from "antd";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const BoothPercentage = ({ electionDetails }) => {
  console.log(electionDetails, "electionDetails");
  // ✅ Percentage of Booths Chart Data
  const barChartData = {
    labels: ["< 45%", "30%-45%", "> 30%", "No Result"],
    datasets: electionDetails?.map((data) => ({
      label: data.year,
      data: [
        data.votePercentage?.above45 || 0,
        data.votePercentage?.thirtyTo45 || 0,
        data.votePercentage?.below30 || 0,
        data.votePercentage?.noResult || 0, // ✅ Fix for No Result
      ],
      backgroundColor:
        data.year === "2024"
          ? "#5555FF"
          : data.year === "2019"
          ? "#FFAA33"
          : "#22AA99",
    })),
  };

  // ✅ Position of Booths Chart Data
  const positionChartData = {
    labels: ["1st Position", "2nd Position", "3rd Position", "No Position"],
    datasets: electionDetails?.map((data) => ({
      label: data.year,
      data: [
        data.position?.first || 0,
        data.position?.second || 0,
        data.position?.third || 0,
        data.position?.noPosition || 0,
      ],
      backgroundColor:
        data.year === "2024"
          ? "#5555FF"
          : data.year === "2019"
          ? "#FFAA33"
          : "#22AA99",
    })),
  };

  // ✅ Repeat of Booths Chart Data
  const repeatBoothsData = {
    labels: ["1st R", "2nd R", "3rd R", "↓ Decrease", "↑ Increase"],
    datasets: electionDetails?.map((data) => ({
      label: data.year,
      data: [
        data.repeat?.FirstPositionRepeat || 0,
        data.repeat?.SecondPositionRepeat || 0,
        data.repeat?.ThirdPositionRepeat || 0,
        data.repeat?.FortuateDecrease || 0,
        data.repeat?.FortuateIncrease || 0,
      ],
      backgroundColor:
        data.year === "2024"
          ? "#5555FF"
          : data.year === "2019"
          ? "#FFAA33"
          : "#22AA99",
    })),
  };

  return (
    <div style={{ padding: "20px" }}>
      {electionDetails?.length > 0 ? (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "20px",
            justifyContent: "center",
          }}
        >
          {/* ✅ Percentage of Booths */}
          <Card
            title="Percentage of Booths"
            style={{ flex: "1 1 300px", minWidth: "300px" }}
          >
            <Bar
              data={barChartData}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                scales: { y: { beginAtZero: true } },
              }}
            />
          </Card>

          {/* ✅ Position of Booths */}
          <Card
            title="Position of Booths"
            style={{ flex: "1 1 300px", minWidth: "300px" }}
          >
            <Bar
              data={positionChartData}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                scales: { y: { beginAtZero: true } },
              }}
            />
          </Card>

          {/* ✅ Repeat of Booths */}
          <Card
            title="Repeat of Booths"
            style={{ flex: "1 1 300px", minWidth: "300px" }}
          >
            <Bar
              data={repeatBoothsData}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                scales: { y: { beginAtZero: true } },
              }}
            />
          </Card>
        </div>
      ) : (
        <p>No election data available</p>
      )}
    </div>
  );
};

export default BoothPercentage;
